export default "__VITE_ASSET__BtyhBYJf__"